import styled from 'styled-components';
import ChartHeaderDisplay from './ChartHeaderDisplay';
import ChartHeaderDescription from './ChartHeaderDescription';
import BetaBadge from './BetaBadge';
import ReplaceReportAction from './ReplaceReportAction';
import AddAnalysisToMenu from './AddAnalysisToMenu';
import { useChartContext } from '../ChartContext';
import { queryTypeConfigLookup } from '../../../utils/queryTypeLookup';
import ChartHeaderDateRange from './ChartHeaderDateRange';
import DuplicateReportButton from './DuplicateReportButton';
import SaveButton from './SaveButton';
import { AnalysisStatus, QueryType } from '../../../utils/apollo/graphqlSchema';
import * as ChartHeaderUI from './ChartHeaderUI';
import * as ChartUI from '../ChartUI';
import useCachedEntitiesSelector from '../../../redux/selectorHooks/useCachedEntitiesSelector';
import { isNil } from 'lodash';
import ChartHeaderPermissions from './ChartHeaderPermissions';
import ChartHeaderIconActions from './ChartHeaderIconActions';
import ChartHeaderFavorite from './ChartHeaderFavorite';
import { ChartViewType } from '../types';
import ShareReportPermissionsWidget from '../../SharePermissionsWidget/ShareReportPermissionsWidget';

import { assertCondition } from '../../../utils/types';
const ActionIconsWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

export default () => {
  const chartContext = useChartContext();
  assertCondition(chartContext.__typename === 'BaseChartContext');
  const {
    metadata: {
      analysisId,
      mode,
      chartView,
      display,
      status,
      queryType,
      query,
      isEmbedded,
    },
    actions: { updateDisplay },
  } = chartContext;
  const { isBeta } = queryTypeConfigLookup[queryType];
  const replaceReport = useCachedEntitiesSelector('replaceReport');
  const isReportPage = queryType !== QueryType.CohortSample;
  const showSaveButton = isReportPage && status === AnalysisStatus.Success;

  const showDuplicateButton =
    isReportPage && status === AnalysisStatus.Success && !query.schema.disabled;
  const showReplaceButton =
    isReportPage && status === AnalysisStatus.Success && !isNil(replaceReport);

  const showAddToMenuButton =
    isReportPage &&
    status === AnalysisStatus.Success &&
    chartView.type === ChartViewType.Default;

  return (
    <ChartUI.Header $mode={mode}>
      <ChartHeaderUI.MainContent>
        <ChartHeaderUI.ChartNameWrapper>
          <ChartHeaderDisplay
            mode={mode}
            chartTitle={display}
            updateChartTitle={updateDisplay}
          />
          {!isEmbedded && <ChartHeaderFavorite />}
          {isBeta && <BetaBadge />}
        </ChartHeaderUI.ChartNameWrapper>
        <ChartHeaderUI.ActionsWrapper>
          <ActionIconsWrapper>
            <ChartHeaderIconActions />
          </ActionIconsWrapper>
          {showReplaceButton && (
            <ReplaceReportAction
              analysisId={analysisId}
              replaceReport={replaceReport}
            />
          )}
          <ShareReportPermissionsWidget />
          {showAddToMenuButton && <AddAnalysisToMenu analysisId={analysisId} />}
          {showDuplicateButton && (
            <DuplicateReportButton analysisId={analysisId} />
          )}
          {showSaveButton && <SaveButton analysisId={analysisId} />}
        </ChartHeaderUI.ActionsWrapper>
      </ChartHeaderUI.MainContent>
      <ChartHeaderUI.SecondaryContent>
        <ChartHeaderDateRange />
        {isReportPage && <ChartHeaderPermissions />}
      </ChartHeaderUI.SecondaryContent>
      <ChartHeaderDescription />
    </ChartUI.Header>
  );
};
